// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__vTwvq","modalFooterButton":"ModalNotes_modalFooterButton__pdfd6"};